/* eslint-disable camelcase */
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import { useAppDispatch, useAppSelector } from "../../../store";
import { clear_user, get_user } from "../../../services/apis/users";
import Button from "../../../component/element/forms/Button";

interface InfoRowProps {
  label: string;
  value: React.ReactNode;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => (
  <div className="flex items-start gap-4 py-3 border-b border-gray-100/20 last:border-0">
    <span className="w-36 shrink-0 text-xs font-semibold uppercase tracking-wider text-gray-400 pt-0.5">
      {label}
    </span>
    <span className="text-sm text-gray-800 font-medium">{value}</span>
  </div>
);

const UserDetails: React.FC = () => {
  const dispatch = useAppDispatch();
  const { email: userId } = useParams();
  const navigate = useNavigate();

  const user = useAppSelector(({ user }) => user.user);
  const loading = useAppSelector(({ user }) => user.loading);

  useEffect(() => {
    if (!userId) return;
    clear_user(dispatch);
    void get_user(dispatch, userId);
  }, [dispatch, userId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <div>User not found</div>;
  }

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-gray-900">User Details</h2>
        </div>
        <Button
          title="Back"
          children={<HiOutlineArrowLongLeft size={18} className="mr-1.5" />}
          onClick={() => navigate(-1)}
          className="flex items-center px-4 py-2 rounded-lg border border-gray-200/20 text-white text-sm font-medium hover:bg-gray-50 shadow-sm transition-colors"
        />
      </div>

      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <h3 className="mb-4 text-lg font-bold text-gray-900">{user.name}</h3>
        <div className="divide-y divide-gray-100">
          <InfoRow label="Email" value={user.email} />
          <InfoRow label="Username" value={user.username} />
          <InfoRow label="Phone number" value={user.phone_number} />
          <InfoRow label="Country ID" value={String(user.country_id)} />
          <InfoRow label="State ID" value={String(user.state_id)} />
          <InfoRow label="Membership" value={user.is_elite ? "Elite" : "Standard"} />
          <InfoRow label="Account status" value={user.is_active ? "Active" : "Inactive"} />
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
